import Multipoint from "@arcgis/core/geometry/Multipoint";
import Point from "@arcgis/core/geometry/Point";
import { IDisposable } from "cd-eft/framework/Disposer";
import { esriGeometryEngine, esriProjection, MapView, SpatialReference } from "cd-eft/utils/esriTypes";
import { convertLinearUnit } from "cd-eft/utils/structureLayerUtils";
import stores from '../../models/Stores';
import { SetupInterpolateTinElevation } from 'cd-eft/framework/TinContourSurface/TinContourSurface';
import { showCoordinates } from 'cd-eft/components/SurveyEngineering/Maps/SETMapFunctions/loadLayers';
import { ElevationInterpolater } from "cd-eft/components/SurveyEngineering/Maps/SETMapFunctions/elevationInterpolationEngine";

const { designStore } = stores.AppStore;

export class SnapTooltipProvider implements IDisposable {
    private _mapView: MapView;
    private _viewPointerMoveHandle;
    private allGroundPointsMP: Multipoint = new Multipoint({ hasZ: true });
    private _spatialReference: SpatialReference;

    constructor(mapView, snappingLayer, projectSR: SpatialReference) {
        this._mapView = mapView;
        this._spatialReference = projectSR;
    }

    public start() {
        if (designStore.coordinateWatchHandler) designStore.coordinateWatchHandler.remove();
        designStore.coordinateWatchHandler = undefined;
        if (this._mapView) this._viewPointerMoveHandle = this._mapView?.on('pointer-move', (event: __esri.ViewPointerMoveEvent) => {
            this.viewPointerMoveHandler(event);
        })
    }

    public stop() {
        this._viewPointerMoveHandle?.remove();
        SetupInterpolateTinElevation(designStore.currentSurface.surfaceDefClassName, this._mapView);
    }

    private async viewPointerMoveHandler(event) {
        const movingPoint = this._mapView?.toMap(event);
        if (movingPoint && this._mapView) {
            const dataPoint: any = esriProjection.project(movingPoint, this._spatialReference);
            await this.findNearestGroundPoint(dataPoint, movingPoint);
        }
    }

    public getSurveyPoints(pointLayer) {
        const pointsArray = pointLayer.graphics.items;
        const multipoint: Multipoint = new Multipoint({ spatialReference: this._spatialReference });
        for (const element of pointsArray) {
            const geom = element.geometry;
            const point = new Point({
                x: geom.x,
                y: geom.y,
                z: convertLinearUnit(geom.z, 'meters', 'intl-feet'),
                hasZ: true,
                spatialReference: { wkid: geom.spatialReference.wkid }
            })
            const projectedPoint: any = esriProjection.project(point, this._spatialReference);
            multipoint.addPoint(projectedPoint);
        }
        this.allGroundPointsMP = multipoint;
    }

    private async findNearestGroundPoint(dataPoint: Point, movingPoint) {
        const findResult = esriGeometryEngine.nearestVertex(this.allGroundPointsMP, dataPoint);
        if (findResult.distance < 21) {
            const index = findResult.vertexIndex;
            showCoordinates({x: findResult.coordinate.x, y: findResult.coordinate.y, z: this.allGroundPointsMP.points[index][2]}, {pointName: designStore.surveyPointNames[index]});    
        } else {
            const z = ElevationInterpolater.Current?.Interpolate(dataPoint.x, dataPoint.y, movingPoint);
            showCoordinates({x: findResult.coordinate.x, y: findResult.coordinate.y, z: z});
        }
    }

    Dispose() {
        this.stop();
    }
}
